import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lingi loomine...

  <span style="color:#85c1dc;">**FI:**</span>
  Linkin luominen...

  <span style="color:#85c1dc;">**RU:**</span>
  Создание ссылки...
*/
/* @__NO_SIDE_EFFECTS__ */
const m1399 = msg(
  mf`Lingi loomine...`,
  mf`Linkin luominen...`,
  mf`Создание ссылки...`,
)

export { m1399 as 'w.wishlist.share.creating' }